const getAuthUrl = (): string => {
  if (import.meta.env.VITE_ENVIRONMENT === 'PRODUCTION') {
    return 'https://itvwin.com/auth';
  }

  return 'https://main.itvwin.com/auth';
};

const realm = 'betzone_uk';

export const baseDomain = 'itvwin.com';

export const config = {
  realm: realm,
  authUrl: getAuthUrl(),
  clientId: 'web-betzone_uk',
  tenantId: 'betzone_uk',
};
